document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ Swatch Collapse Fix Loaded");

  // =========================
  // Swatch Collapse Fix
  // =========================
  function enableSwatchButton() {
    console.log("✅ Enabling '+ More' Button...");

    document.querySelectorAll(".gsw-list-products-group").forEach(wrapper => {
      let swatches = Array.from(wrapper.querySelectorAll(".gsw-prg-item")); // Convert to array

      // Remove existing "+ More" button to prevent duplication
      wrapper.querySelectorAll(".gsw-more-button").forEach(btn => btn.remove());

      if (swatches.length > 4) {
        let moreButton = document.createElement("button");
        moreButton.innerHTML = "+";
        moreButton.classList.add("gsw-more-button");

        // Insert button **before** the first swatch
        wrapper.insertBefore(moreButton, swatches[0]);

        // **Ensure only the first 4 swatches are visible initially**
        swatches.forEach((swatch, index) => {
          if (index >= 4) {
            swatch.style.display = "none"; // Hide extra swatches
          } else {
            swatch.style.display = "inline-block"; // Show first 4 swatches
          }
        });

        // **Expand/collapse swatches on button click**
        moreButton.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation(); // Prevent conflicts with other scripts
          let isExpanded = wrapper.classList.toggle("expanded");

          if (isExpanded) {
            console.log("➡️ Expanding swatches...");
            swatches.forEach(swatch => swatch.style.display = "inline-block");
            moreButton.innerHTML = "-";
          } else {
            console.log("↩️ Collapsing swatches...");
            swatches.forEach((swatch, index) => {
              if (index >= 4) swatch.style.display = "none";
            });
            moreButton.innerHTML = "+";
          }
        });
      }
    });
  }

  function initializeSwatchFix() {
    enableSwatchButton();
  }

  function waitForSwatchFix() {
    let checkExist = setInterval(() => {
      let swatchGroups = document.querySelectorAll(".gsw-list-products-group");
      if (swatchGroups.length > 0) {
        console.log("✅ Swatches detected! Running initializeSwatchFix...");
        clearInterval(checkExist);
        initializeSwatchFix();
      }
    }, 500);
  }

  // 🚀 Fix for Shopify Section Reloads
  document.addEventListener("shopify:section:load", function () {
    console.log("🔄 Shopify Section Reload Detected - Reinitializing Swatch Fix");
    setTimeout(initializeSwatchFix, 500);
  });

  waitForSwatchFix();
});

// =========================
// AJAX Add to Cart + Tracking
// =========================
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a.add_to_cart_button[data-id]').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const productId = link.dataset.id;
      const productCard = link.closest('.product-card');
      const productName = productCard?.querySelector('.product-title')?.textContent?.trim() || "Unknown Product";
      const productPrice = parseFloat(productCard?.querySelector('.product-price')?.textContent?.replace(/[^0-9.]/g, '')) || 0;

      // ✅ Shopify AJAX Add to Cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productId, quantity: 1 })
      })
      .then(res => res.json())
      .then(data => {
        console.log("✅ Product added via AJAX:", data);

        const uniqueID = Date.now();

        // ✅ Klaviyo tracking
        if (window._learnq) {
          window._learnq.push(['track', 'Added to Cart', {
            Name: productName,
            ProductID: productId,
            Brand: "Von Dutch",
            Price: productPrice,
            Quantity: 1,
            URL: window.location.href,
            _unique: uniqueID
          }]);
          console.log("✅ Klaviyo Add to Cart pushed with ID:", uniqueID);
        }

        // ✅ dataLayer push for Shopify pixel or GTM
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "product_added_to_cart",
          ecommerce: {
            items: [{
              item_name: productName,
              item_id: productId,
              price: productPrice,
              quantity: 1
            }]
          }
        });
        console.log("✅ dataLayer Add to Cart event pushed");

        // ✅ Update cart + progress bar
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new Event('ajaxProduct:added'));

        // ✅ Open Cart Drawer
        setTimeout(() => {
          const cartDrawer = document.querySelector('cart-drawer');
          const isDrawerOpen = cartDrawer?.hasAttribute('open');
          if (!isDrawerOpen && typeof window?.Shopify?.theme?.openCartDrawer === 'function') {
            window.Shopify.theme.openCartDrawer();
          }
        }, 800);
      })
      .catch(err => {
        console.error("🛑 Error adding to cart:", err);
      });
    });
  });
});

// =========================
// Free Shipping Progress Bar + Float Count
// =========================
function updateFreeShippingProgress(cart) {
  const freeShippingEl = document.querySelector('.free-shipping');
  if (!freeShippingEl) return;

  const cartTotal = cart.total_price;
  const minimum = parseInt(freeShippingEl.dataset.minimum, 10);

  const remaining = Math.max(minimum - cartTotal, 0);
  const percent = Math.min((cartTotal / minimum) * 100, 100);

  const textRemaining = freeShippingEl.querySelector('.free-shipping--text-remaining');
  const textFull = freeShippingEl.querySelector('.free-shipping--text-full');
  const bar = freeShippingEl.querySelector('.free-shipping--percentage');

  if (textRemaining) {
    textRemaining.style.display = remaining > 0 ? 'block' : 'none';
    textRemaining.innerHTML = `Spend <strong>$${(remaining / 100).toFixed(2)}</strong> more for free shipping!`;
  }

  if (textFull) {
    textFull.style.display = remaining === 0 ? 'block' : 'none';
  }

  if (bar) {
    bar.style.width = `${percent}%`;
  }
}

function updateFloatCount(cart) {
  const floatCountEl = document.querySelector('.float_count');
  if (!floatCountEl) return;

  const totalQuantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);
  floatCountEl.textContent = totalQuantity;
}

function refreshCartAndProgress(delay = 300) {
  setTimeout(() => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        updateFreeShippingProgress(cart);
        updateFloatCount(cart);
      });
  }, delay);
}

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  refreshCartAndProgress(0);
});

// On cart:refresh
document.addEventListener('cart:refresh', () => {
  refreshCartAndProgress();
});

// On + or − buttons
document.addEventListener('click', function (e) {
  if (e.target.closest('.qty-btn')) {
    refreshCartAndProgress(600);
  }
});

// On product added via AJAX
document.addEventListener('ajaxProduct:added', () => {
  refreshCartAndProgress(500);
});

// On remove
document.body.addEventListener('click', function (e) {
  if (e.target.closest('.remove')) {
    refreshCartAndProgress(500);
  }
});


// document.addEventListener("DOMContentLoaded", function () {
//     console.log("✅ Swatch Collapse Fix Loaded");

//     function enableSwatchButton() {
//         console.log("✅ Enabling '+ More' Button...");

//         document.querySelectorAll(".gsw-list-products-group").forEach(wrapper => {
//             let swatches = Array.from(wrapper.querySelectorAll(".gsw-prg-item")); // Convert to array

//             // Remove existing "+ More" button to prevent duplication
//             wrapper.querySelectorAll(".gsw-more-button").forEach(btn => btn.remove());

//             if (swatches.length > 4) {
//                 let moreButton = document.createElement("button");
//                 moreButton.innerHTML = "+";
//                 moreButton.classList.add("gsw-more-button");

//                 // Insert button **before** the first swatch
//                 wrapper.insertBefore(moreButton, swatches[0]);

//                 // **Ensure only the first 4 swatches are visible initially**
//                 swatches.forEach((swatch, index) => {
//                     if (index >= 4) {
//                         swatch.style.display = "none"; // Hide extra swatches
//                     } else {
//                         swatch.style.display = "inline-block"; // Show first 4 swatches
//                     }
//                 });

//                 // **Expand/collapse swatches on button click**
//                 moreButton.addEventListener("click", function (event) {
//                     event.preventDefault();
//                     event.stopPropagation(); // Prevent conflicts with other scripts
//                     let isExpanded = wrapper.classList.toggle("expanded");

//                     if (isExpanded) {
//                         console.log("➡️ Expanding swatches...");
//                         swatches.forEach(swatch => swatch.style.display = "inline-block");
//                         moreButton.innerHTML = "-";
//                     } else {
//                         console.log("↩️ Collapsing swatches...");
//                         swatches.forEach((swatch, index) => {
//                             if (index >= 4) swatch.style.display = "none";
//                         });
//                         moreButton.innerHTML = "+";
//                     }
//                 });
//             }
//         });
//     }

//     function initializeSwatchFix() {
//         enableSwatchButton();
//     }

//     function waitForSwatchFix() {
//         let checkExist = setInterval(() => {
//             let swatchGroups = document.querySelectorAll(".gsw-list-products-group");

//             if (swatchGroups.length > 0) {
//                 console.log("✅ Swatches detected! Running initializeSwatchFix...");
//                 clearInterval(checkExist);
//                 initializeSwatchFix();
//             }
//         }, 500);
//     }

//     // 🚀 Fix for Shopify Section Reloads
//     document.addEventListener("shopify:section:load", function () {
//         console.log("🔄 Shopify Section Reload Detected - Reinitializing Swatch Fix");
//         setTimeout(initializeSwatchFix, 500);
//     });

//     waitForSwatchFix();
//     //updateFreeShippingProgress(cart);
// });
// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll('a.add_to_cart_button[data-id]').forEach(link => {
//     link.addEventListener('click', function (e) {
//       e.preventDefault();

//       const productId = link.dataset.id;
//       const productCard = link.closest('.product-card');
//       const productName = productCard?.querySelector('.product-title')?.textContent?.trim() || "Unknown Product";
//       const productPrice = parseFloat(productCard?.querySelector('.product-price')?.textContent?.replace(/[^0-9.]/g, '')) || 0;

//       // ✅ Shopify AJAX Add to Cart
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: productId, quantity: 1 })
//       })
//       .then(res => res.json())
//       .then(data => {
//         console.log("✅ Product added via AJAX:", data);

//         const uniqueID = Date.now();

//         // ✅ Klaviyo tracking
//         if (window._learnq) {
//           window._learnq.push(['track', 'Added to Cart', {
//             Name: productName,
//             ProductID: productId,
//             Brand: "Von Dutch",
//             Price: productPrice,
//             Quantity: 1,
//             URL: window.location.href,
//             _unique: uniqueID
//           }]);
//           console.log("✅ Klaviyo Add to Cart pushed with ID:", uniqueID);
//         }

//         // ✅ dataLayer push for Shopify pixel or GTM
//         window.dataLayer = window.dataLayer || [];
//         window.dataLayer.push({
//           event: "product_added_to_cart",
//           ecommerce: {
//             items: [{
//               item_name: productName,
//               item_id: productId,
//               price: productPrice,
//               quantity: 1
//             }]
//           }
//         });

//         console.log("✅ dataLayer Add to Cart event pushed");

//         // Optional: show cart drawer or reload
//         if (window.location.pathname !== '/cart') {
//           fetch('/cart.js')
//             .then(res => res.json())
//             .then(cart => {
//               console.log('🛒 Updated Cart:', cart);
//               // Optional: refresh mini-cart UI if needed
//             });
//         }

//       })
//       .catch(err => {
//         console.error("🛑 Error adding to cart:", err);
//       });
//     });
//   });
// });


// // ✅ Global one-time listener (put in theme.js or global file)
// document.addEventListener('DOMContentLoaded', function () {
//   document.body.addEventListener('click', function (e) {
//     const button = e.target.closest('.add_to_cart_button[data-id]');
//     if (!button) return;

//     setTimeout(() => {
//       const cartDrawer = document.querySelector('cart-drawer');
//       const isDrawerOpen = cartDrawer?.hasAttribute('open');

//       if (!isDrawerOpen && typeof window?.Shopify?.theme?.openCartDrawer === 'function') {
//         window.Shopify.theme.openCartDrawer();
//       }
//       //document.dispatchEvent(new CustomEvent('cart:refresh'));
//     }, 1000);
//   });
// });

// // ✅ New remove button click handler
// document.body.addEventListener('click', function (e) {
//   const removeBtn = e.target.closest('.remove');
//   if (!removeBtn) return;
//   // Wait for Shopify to process the removal
//   setTimeout(() => {
//     //document.dispatchEvent(new CustomEvent('cart:refresh'));
//   }, 1000);
// });

// function updateFreeShippingProgress(cart) {
//   const freeShippingEl = document.querySelector('.free-shipping');
//   if (!freeShippingEl) return;

//   const cartTotal = cart.total_price;
//   const minimum = parseInt(freeShippingEl.dataset.minimum, 10);

//   //freeShippingEl.dataset.cartTotal = cartTotal;

//   const remaining = Math.max(minimum - cartTotal, 0);
//   const percent = Math.min((cartTotal / minimum) * 100, 100);

//   const textRemaining = freeShippingEl.querySelector('.free-shipping--text-remaining');
//   const textFull = freeShippingEl.querySelector('.free-shipping--text-full');
//   const bar = freeShippingEl.querySelector('.free-shipping--percentage');

//   if (textRemaining) {
//     textRemaining.style.display = remaining > 0 ? 'block' : 'none';
//     textRemaining.innerHTML = `Spend <strong>$${(remaining / 100).toFixed(2)}</strong> more for free shipping!`;
//   }

//   if (textFull) {
//     textFull.style.display = remaining === 0 ? 'block' : 'none';
//   }

//   freeShippingEl.dataset.cartTotal = cartTotal;
//   // Trigger re-initialization
//   freeShippingEl.connectedCallback?.(); // If manually needed

// }

// function updateFloatCount(cart) {
//   const floatCountEl = document.querySelector('.float_count');
//   if (!floatCountEl) return;

//   let totalQuantity = 0;
//   cart.items.forEach(item => {
//     totalQuantity += item.quantity;
//   });

//   floatCountEl.textContent = totalQuantity;
// }


// function refreshCartAndProgress(delay = 300) {
//   setTimeout(() => {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         updateFreeShippingProgress(cart);
//         updateFloatCount(cart); // ✅ Add this line
//       });
//   }, delay);
// }


// // function refreshCartAndProgress(delay = 300) {
// //   setTimeout(() => {
// //     fetch('/cart.js')
// //       .then(res => res.json())
// //       .then(cart => updateFreeShippingProgress(cart));
// //   }, delay);
// // }

// // Initial load
// document.addEventListener('DOMContentLoaded', () => {
//   refreshCartAndProgress(0);
// });

// // On cart:refresh
// document.addEventListener('cart:refresh', () => {
//   refreshCartAndProgress();
 
// });

// // On + or − buttons
// document.addEventListener('click', function (e) {
//   if (e.target.closest('.qty-btn')) {
//     refreshCartAndProgress(600); // Slightly longer delay after qty change
//   }
// });

// // On product added via AJAX
// document.addEventListener('ajaxProduct:added', () => {
//   refreshCartAndProgress(500);
// });


// // function updateFreeShippingProgress(cart) {
// //   const freeShippingEl = document.querySelector('.free-shipping');
// //   if (!freeShippingEl) return;

// //   const cartTotal = cart.total_price;
// //   const minimum = parseInt(freeShippingEl.dataset.minimum, 10);

// //   freeShippingEl.dataset.cartTotal = cartTotal;

// //   const remaining = Math.max(minimum - cartTotal, 0);
// //   const percent = Math.min((cartTotal / minimum) * 100, 100);

// //   const textRemaining = freeShippingEl.querySelector('.free-shipping--text-remaining');
// //   const textFull = freeShippingEl.querySelector('.free-shipping--text-full');
// //   const bar = freeShippingEl.querySelector('.free-shipping--percentage');

// //   if (textRemaining) {
// //     textRemaining.style.display = remaining > 0 ? 'block' : 'none';
// //     textRemaining.innerHTML = `Spend <strong>$${(remaining / 100).toFixed(2)}</strong> more for free shipping!`;
// //   }

// //   if (textFull) {
// //     textFull.style.display = remaining === 0 ? 'block' : 'none';
// //   }

// //   if (bar) {
// //     //bar.style.width = `${percent}%`;
// //     bar.style.width = percent >= 100 ? '100%' : `${percent}%`;

// //   }
// // }


// // // Run this on cart:refresh
// // document.addEventListener('cart:refresh', () => {
// //   fetch('/cart.js')
// //     .then(res => res.json())
// //     .then(cart => {
// //       updateFreeShippingProgress(cart);
// //     });
// // });

// // // Update on quantity button clicks
// document.addEventListener('click', function (e) {
//   if (!e.target.classList.contains('remove')) return;
//     updateFreeShippingProgress(cart);
//   // setTimeout(() => {
//   //   fetch('/cart.js')
//   //     .then(res => res.json())
//   //     .then(cart => {
//   //       updateFreeShippingProgress(cart);
//   //     });
//   // }, 30);
// });

